import React from 'react';
import { instanceOf, bool } from 'prop-types';
import { DragLayer as dragLayer } from 'react-dnd';
import _ from 'lodash';

function collect(monitor) {
  return {
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
    clientOffset: monitor.getClientOffset(),
  };
}

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '20%',
  height: '100%',
};

const getItemStyles = clientOffset => {
  if (!clientOffset) {
    return {
      display: 'none',
    };
  }
  const { x, y } = clientOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
};

const TCDragLayer = ({ items, isDragging, clientOffset }) => {
  if (!isDragging) {
    return false;
  }
  return (
    <div style={layerStyles}>
      <div className="drag-preview" style={getItemStyles(clientOffset)}>
        <ul>
          {_.map(items, (item, i) => (
            <li key={i}>{item.title}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

TCDragLayer.propTypes = {
  items: instanceOf(Array),
  isDragging: bool,
  clientOffset: instanceOf(Object),
};

TCDragLayer.defaultProps = {
  items: [],
  isDragging: false,
};

export default dragLayer(collect)(TCDragLayer);
